import { RequestOptions, Headers } from '@angular/http';

//you can move this class to a better place
export class GlobalHttpOptions extends RequestOptions {
    constructor() {
        super({
            withCredentials: true
        });
    }
}


// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/global-http-options.ts